<template>
  <div style='position: relative;'>
    <a href='#' class='button button--secondary' @click.prevent.stop="isShown = true"><i :class='icon'></i>{{name}} ({{amount}})</a>
    <div class='duplicator duplicator__large' v-if='isShown'>
      <slot></slot>
      <a href='#' class='button button--secondary' @click.prevent.stop="isShown = false">Cancel</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "icon", "amount"],
  mounted () {
    
  },
  data () {
    return {
      isShown: false
    }
  }
}
</script>

